import { type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import MaintenancePage from '../../pages/maintenance/page';
import { useMaintenanceMode } from '../../hooks/useMaintenanceMode';

interface MaintenanceGateProps {
  children: ReactNode;
}

const WHITELISTED_PATHS = ['/admin'];

export default function MaintenanceGate({ children }: MaintenanceGateProps) {
  const location = useLocation();
  const { config, loading } = useMaintenanceMode();

  const isWhitelisted = WHITELISTED_PATHS.some((p) =>
    location.pathname.startsWith(p)
  );

  // While loading, we show the children (default to not maintenance)
  // or we could show a loading spinner. Given the app nature, showing children is safer.
  if (!loading && config.enabled && !isWhitelisted) {
    return <MaintenancePage />;
  }

  return <>{children}</>;
}